import { Link } from "react-router-dom";
import { articlePath, clock, timeAgo } from "@/lib/api";

export function LiveFeed({ items, fresh }) {
  return (
    <section data-testid="live-feed" className="flex h-full flex-col rounded-xl border bg-card">
      <div className="flex items-center justify-between border-b px-4 py-3">
        <h2 className="flex items-center gap-2 font-serif-display text-xl font-black">
          <span className="relative flex h-2.5 w-2.5"><span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary opacity-75" /><span className="relative h-2.5 w-2.5 rounded-full bg-primary" /></span>
          Ao minuto
        </h2>
        <span className="font-mono-meta text-[10px] uppercase tracking-widest text-muted-foreground">Atualização automática</span>
      </div>
      <ol className="no-scrollbar max-h-[520px] flex-1 overflow-y-auto px-4">
        {items.map((a) => (
          <li key={a.id} className={`relative border-l-2 py-3 pl-4 ${fresh.has(a.id) ? "border-primary bg-primary/5 rise" : "border-border"}`}>
            <span className="absolute -left-[5px] top-4 h-2 w-2 rounded-full bg-primary" />
            <Link to={articlePath(a)} data-testid={`live-item-${a.id}`} className="group block">
              <p className="font-mono-meta text-[11px] font-bold text-primary">{clock(a.date)} · {timeAgo(a.date)}{fresh.has(a.id) && <span className="ml-2 rounded bg-primary px-1.5 text-[9px] text-white">NOVO</span>}</p>
              <p className="mt-0.5 text-[14px] font-semibold leading-snug group-hover:text-primary line-clamp-2">{a.title}</p>
              <p className="font-mono-meta text-[10px] uppercase text-muted-foreground">{a.source}</p>
            </Link>
          </li>
        ))}
      </ol>
    </section>
  );
}
